import { Route, Routes } from "react-router-dom";

import AllLists from "./AllLists";
import LeadListDetails from "./LeadListDetails";

export default function Lists() {
  return (
    <Routes>
      <Route path="/" element={<AllLists />} />
      <Route path="/:listId/*">
        <Route path="sources/new/:sourceType" element={<div></div>} />
        <Route path="" element={<LeadListDetails />} />
      </Route>
    </Routes>
  );
}
